import { useState, useEffect } from 'react';
import { ServicePage } from './components/ServicePage';
import { services } from './data/services';

export default function App() {
  const [currentService, setCurrentService] = useState('shower-doors');

  // Handle URL routing (simple hash-based routing)
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove #
      const slug = hash.replace('/services/', '');
      if (services[slug]) {
        setCurrentService(slug);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    // Set initial route
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleNavigate = (slug: string) => {
    window.location.hash = `/services/${slug}`;
  };

  const service = services[currentService];

  if (!service) {
    return <div>Service not found</div>;
  }

  return <ServicePage service={service} onNavigate={handleNavigate} />;
}
